export default {
  IWAVE: 'iWave',
  IWAVE_AUTH_CALLBACK_INSTRUCTIONS: 'Processing iWave connection...',
  IWAVE_CONSTITUENT_CONNECTING: 'Connecting...',
  IWAVE_CONSTITUENT_UPDATING: 'Updating...',
  IWAVE_CONSTITUENT_UPDATE_ERROR:
    'There was an error with updating the iWave data',
  IWAVE_CONSTITUENT_CONNECTION_ERROR: 'Error: No records found',
  IWAVE_CONSTITUENT_IWAVE_ID: 'iWave ID#: {id}',
  IWAVE_CONSTITUENT_ID_LABEL: 'iWave ID#',
  IWAVE_CONSTITUENT_ID_REQUIRED: 'The iWave ID# is required',
  IWAVE_DETAILED_SUMMARY_AMOUNT_DATE_DETAILS: '{amount} - {date}',
  IWAVE_DETAILED_SUMMARY_BASE_COMPENTATION_TERM:
    'Established Base Compensation:',
  IWAVE_DETAILED_SUMMARY_DESCRIPTION:
    'Something here about how these are the main numbers that contributed to the overall score.',
  IWAVE_DETAILED_SUMMARY_GIVING_BREAKDOWN_SUBHEADER: 'Giving Breakdown',
  IWAVE_DETAILED_SUMMARY_HEADER: 'Details',
  IWAVE_DETAILED_SUMMARY_LARGEST_ESTIMATE_TERM: 'Largest Estimated Capacity:',
  IWAVE_DETAILED_SUMMARY_LARGEST_GIFT_TERM: 'Largest Gift:',
  IWAVE_DETAILED_SUMMARY_OVERVIEW_SUBHEADER: 'Overview',
  IWAVE_DETAILED_SUMMARY_REAL_ESTATE_TERM: 'Real Estate Total Value:',
  IWAVE_DETAILED_SUMMARY_RECENT_GIFT_TERM: 'Most Recent Gift:',
  IWAVE_SCORE_EVALUATION_1: '1 - Weak',
  IWAVE_SCORE_EVALUATION_2: '2 - Fair',
  IWAVE_SCORE_EVALUATION_3: '3 - Good',
  IWAVE_SCORE_EVALUATION_4: '4 - Strong',
  IWAVE_DETAILED_SUMMARY_SCORE_TERM: 'Wealth Score:',
  IWAVE_DETAILED_SUMMARY_TOTAL_GIFTS_AMOUNT_TERM:
    'Total Charitable Gifts Amount:',
  IWAVE_DETAILED_SUMMARY_TOTAL_GIFTS_NUMBER_TERM:
    'Total Number of Charitable Gifts:',
  IWAVE_DETAILED_SUMMARY_TOTAL_RELEASE_PROPERTIES_TERM:
    'Total Number of Release Properties:',
  IWAVE_EVALUATION_FAIR: 'Fair',
  IWAVE_EVALUATION_GOOD: 'Good',
  IWAVE_EVALUATION_STRONG: 'Strong',
  IWAVE_EVALUATION_WEAK: 'Weak',
  IWAVE_FILTER_AFFINITY_LABEL: 'Affinity',
  IWAVE_FILTER_CAPACITY_LABEL: 'Capacity',
  IWAVE_FILTER_IWAVE_LABEL: 'iWave',
  IWAVE_FILTER_PLANNED_GIVING: 'Planned Giving',
  IWAVE_FILTER_PROPENSITY_LABEL: 'Propensity',
  IWAVE_FILTER_SUBHEADER: 'iWave Scores',
  IWAVE_HOVERCARD_EVALUATION: 'iWave Score:',
  IWAVE_INTEGRATION_CONNECTION_CONNECTED_DESCRIPTION:
    'iWave is connected. The ability to connect new IWave data can now be found on constituent profiles.',
  IWAVE_INTEGRATION_CONNECTION_CTA: 'Connect to iWave',
  IWAVE_INTEGRATION_CONNECTION_EDIT: 'Change iWave ID',
  IWAVE_INTEGRATION_CONNECTION_UPDATE: 'Update',
  IWAVE_INTEGRATION_CONNECTION_DESCRIPTION:
    'You will be redirected to iWave to finish connection.',
  IWAVE_INTEGRATION_CONNECTION_GLOBAL_REFRESH_DATE: 'Last Uploaded: {date}',
  IWAVE_INTEGRATION_CONNECTION_HEADER: 'Connect to iWave',
  IWAVE_INTEGRATION_CONNECTION_REFRESH_CTA: 'Refresh all iWave contacts',
  IWAVE_INTEGRATION_CONNECTION_REFRESH_DATE:
    'Updated in Instil {instilDate} | Updated In iWave {iWaveDate}',
  IWAVE_INTEGRATION_CONNECTION_REFRESH_DESCRIPTION:
    'Refresh iWave data. An email will be sent when the update has completed.',
  IWAVE_INTEGRATION_DESCRIPTION:
    'iWave is a service focused on helping you find ideal donors and cultivate relationships.',
  IWAVE_SCORE_BREAKDOWN_AFFINITY_DESCRIPTION: 'Linkage to your mission',
  IWAVE_SCORE_BREAKDOWN_AFFINITY_HEADER: 'Affinity',
  IWAVE_SCORE_BREAKDOWN_CAPACITY_DESCRIPTION: 'Ability to give',
  IWAVE_SCORE_BREAKDOWN_CAPACITY_HEADER: 'Capacity',
  IWAVE_SCORE_BREAKDOWN_HEADER: 'Score Breakdown',
  IWAVE_SCORE_BREAKDOWN_PLANNED_GIVING_DESCRIPTION: 'Ability to give',
  IWAVE_SCORE_BREAKDOWN_PLANNED_GIVING_HEADER: 'Planned Giving',
  IWAVE_SCORE_BREAKDOWN_PROPENSITY_DESCRIPTION: 'Inclination to Give',
  IWAVE_SCORE_BREAKDOWN_PROPENSITY_HEADER: 'Propensity',
  IWAVE_SCORE_BREAKDOWN_RFM_DESCRIPTION: 'Inclination to Give',
  IWAVE_SCORE_BREAKDOWN_RFM_HEADER: 'RFM',
  IWAVE_SCORE_BREAKDOWN_SCORE_DESCRIPTION: 'Overall Score',
  IWAVE_SCORE_BREAKDOWN_SCORE_HEADER: 'iWave Score',
};
